import { Button } from "../Button"
import { Input, Label } from "../Form"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../Modal"

export const NewAssistanceModalConfirm = ({
  openNewAssistance,
  handleOpenAssistance,
  handleNewAssitanceConfirm = () => { },
  register,
  watch
}) => {
  return (
    <ModalPanel modalIsOpen={openNewAssistance}>
      <ModalHeader title="Registrar novo atendimento" closeModal={handleOpenAssistance} buttonCloseDisabled={!watch("assistanceTitle")} />
      <ModalBody>
        <Label label="Titulo do atendimento" />
        <Input
          hasFocus={false}
          register={register("assistanceTitle", {
            required: { value: true, message: "Campo Obrigatório" },
          })}
        />
      </ModalBody>
      <ModalFooter>
        <Button label="Salvar" isDisabled={!watch("assistanceTitle")} handleClick={handleNewAssitanceConfirm} />
      </ModalFooter>
    </ModalPanel>
  )
}